import { Navigate, Route, Routes } from 'react-router-dom';

import { MenuInfo } from 'data';
import { MonitoringSettingTabsLayout } from 'layout/monitoring';
import usePermission from 'hooks/usePermission';
import RouteAccessError from 'pages/RouteAccessError';

export default function MonitoringSettingTabsRoutes(props) {
    const { menuId } = props;
    const tabs = MenuInfo.ROOT.find(menuId);
    // console.log(tabs)

    const { hasPermission, isPermissionReady } = usePermission();
    if (!isPermissionReady) {
        return null;
    }
    const tabsVisible =
        (!tabs.permission || hasPermission(tabs.permission)) &&
        (tabs.feature === undefined || tabs.feature);
    // console.log(tabsVisible)
        
    const visibleMenus = tabs.children.filter(menu => {
        const permissionOk =
            !menu.permission || hasPermission(menu.permission);

        const featureOk =
            menu.feature === undefined || menu.feature;

        return permissionOk && featureOk;
    });
    // console.log(visibleMenus)

    // if (visibleMenus?.length > 0) {
        return (
            <Routes>
                <Route path="/*" element={ <MonitoringSettingTabsLayout menuId={menuId}/> }>
                    {tabsVisible && (
                        <>
                        <Route path="/*" element={ <Navigate to={visibleMenus[0]?.path}/> }/>
                        {
                            visibleMenus.map(child => {
                                return (
                                    <Route key={child.id} path={child.path + (child.isMultiPageMenu ? '/*' : '')} element={ child.element }/>
                                );
                            }) 
                        }
                        </>
                    )}
                    <Route path="*" element={ <RouteAccessError/> }/>
                </Route>
            </Routes>
        );
    // } else {
    //     return (
    //         <Routes>
    //             <Route path="/*" element={ <MonitoringSettingLayout menuId={menuId}/> }>
    //                 {tabsVisible && (
    //                 <>
    //                     <Route path="/*" element={ <Navigate to={visibleMenus[0]?.path}/> }/>
    //                     {
    //                         visibleMenus.map(child => {
    //                             return (
    //                                 <Route key={child.id} path={child.path + (child.isMultiPageMenu ? '/*' : '')} element={ child.element }/>
    //                             );
    //                         }) 
    //                     }
    //                     </>
    //                 )}
    //                 <Route path="*" element={ <Error404/> }/>
    //             </Route>
    //         </Routes>
    //     );
    // }
}